module.exports = __webpack_public_path__ + "static/media/0327_IMG_LA_CAVE.0e65d6af.png";